function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#587a8d;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.74,77.29s1.36,1.09,6.86,1.09a34.18,34.18,0,0,0,9.08-1.09,48.31,48.31,0,0,0-1,8.33,44.16,44.16,0,0,0,1,8.1H40L26.74,80Z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 34.62,
  y: 66.5,
  width: 31.23,
  height: 4.71
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 34.62,
  y: 57.31,
  width: 31.23,
  height: 4.71
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "71.34 56.51 71.34 91.97 41.83 91.97 28.49 78.19 28.49 56.51 24.06 56.51 24.06 79.98 39.95 96.39 75.77 96.39 75.77 56.51 71.34 56.51"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M71.72,8.37V21.44H28.28V8.37H71.72M76.58,3.5H23.42V26.31H76.58V3.5Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,29.73V63.57a9.58,9.58,0,0,0,9.58,9.58h10V52.44H80.46V73.15h10A9.58,9.58,0,0,0,100,63.57V29.73a9.58,9.58,0,0,0-9.58-9.58H9.58A9.58,9.58,0,0,0,0,29.73Zm87.91,7.09a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,87.91,36.82Z"
});

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Print Button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.ceb946ca.svg";
export { ForwardRef as ReactComponent };